import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import AuthAxios from "../../../config/authAxios";
import apiRoutes from "../../apiConfigs";

export const EditEventModuleSettingApi = createAsyncThunk(
  "auth/event/EditEventModuleSetting",
  async (data, { rejectWithValue }) => {
    try {
      const response = await AuthAxios.patch(apiRoutes.publicapiAction(`events_setting`, 1),
        data
      );
      return response?.data;
    } catch (error) {
      return rejectWithValue(error?.response?.data);
    }
  }
);

const EditEventModuleSettingSlice = createSlice({
  name: "Edit EventModuleSetting",
  initialState: { result: [], loading: false, error: null, message: "" },
  extraReducers: (builder) => {
    builder.addCase(EditEventModuleSettingApi.pending, (state, action) => {
      state.loading = true;
    });
    builder.addCase(EditEventModuleSettingApi.fulfilled, (state, action) => {
      state.loading = false;
      state.result = action?.payload?.result;
      state.message = action?.payload?.message;
    });
    builder.addCase(EditEventModuleSettingApi.rejected, (state, action) => {
      state.loading = false;
      state.error = action?.payload?.error;
      state.message = action?.payload?.message;
    });
  },
});

export const EditEventModuleSettingreducer = EditEventModuleSettingSlice.reducer;
